var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackofficeMenuContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 0.900391H1.8C0.8 0.900391 0 1.70039 0 2.70039V22.3004C0 23.3004 0.8 24.1004 1.8 24.1004H23.2C24.2 24.1004 25 23.3004 25 22.3004V2.70039C25 1.70039 24.2 0.900391 23.2 0.900391ZM17.9 2.70039H21.5V4.50039H17.9V2.70039ZM23.2 22.3004H1.8V6.20039H23.2V22.3004Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7001 15.2002H3.6001V17.0002H10.7001V15.2002Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7001 18.8008H3.6001V20.6008H10.7001V18.8008Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4001 15.2002H14.3V17.0002H21.4001V15.2002Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4001 18.8008H14.3V20.6008H21.4001V18.8008Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5001 8H3.6001V13.4H21.5001V8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackofficeMenuContent);
export default __webpack_public_path__ + "static/media/backoffice_menu_content.9bb28f7bbc133e341a3ff93f3ee6209d.svg";
export { ForwardRef as ReactComponent };